<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="sidebarx" spacer v-model="addTimeKeepingConfig.isOpen" id="add-time-keeping">
        <div class="flex items-center justify-between px-6">
            <h4 class="text-2xl font-bold">Add Time Keeping</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
            <div class="sidebar-content p-6">
                <div class="info-form mb-base">
                    <h4 class="text-lg font-bold m-0 mb-2">Staff</h4>
                    <v-select @input="selectId($event)" v-model="staffName" :options="staffList" label="name" :clearable="false" :class="{'invalid-staff' : !validStaff}" />

                    <p class="text-danger text-sm mt-2 d-none">Staff is required</p>

                    <div class="flex" :class="{'error-date-time': !validDateTime}">
                        <div class="w-1/2 pr-3">
                            <h4 class="text-lg font-bold m-0 mt-6">In</h4>
                            <!-- <datepicker v-model="in_date" class="input-schedule"></datepicker> -->
                            <flat-pickr :config="configdateTimePicker" v-model="in_date" class="input-schedule" />
                        </div>

                        <div class="w-1/2 pl-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Out</h4>
                            <!-- <datepicker :disabledDates="disabledDates" v-model="out_date" class="input-schedule second-datepicker"></datepicker> -->
                            <div class="w-full position-relative">
                                <flat-pickr :config="configdateTimePicker" v-model="out_date" :disabledDates="disabledDates" clearable class="input-schedule second-datepicker" />
                                <feather-icon icon="XIcon" @click.stop="" svgClasses="h-6 w-6" class="cursor-pointer close-datetime-icon" v-if="out_date" @click="out_date = null"></feather-icon>
                            </div>
                        </div>
                    </div>

                    <p class="text-danger text-sm mt-2 d-none error-date-time-text">** Out time must be greater than in time!!</p>

                    <h4 class="text-lg font-bold m-0 mt-6 mb-2">Note</h4>
                    <vs-textarea :maxlength="max_length_note" v-model="note" :counter="max_length_note" :counter-danger.sync="counterDanger" height="150" />
                </div>
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
            <vs-button class="mr-6" @click.stop="addTimeKeeping" style="min-width: 140px;">Save</vs-button>
            <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment'
export default {
    name: 'add-time-keeping',
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar
    },
    props: {
        addTimeKeepingConfig: {
            type: Object
        }
    },
    data() {
        return {
            in_date: new Date(),
            out_date: this.in_date ? this.in_date : new Date(),
            note: '',
            max_length_note: 160,
            counterDanger: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            selectedId: '',
            staffName: '',
            disabledDates: {
              to: this.in_date ? new Date(this.in_date.getFullYear(), this.in_date.getMonth(), this.in_date.getDate())
              : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            },
            configdateTimePicker: {
                enableTime: true,
                // dateFormat: 'Y-m-d 00:00:00'
                // dateFormat: 'Y-m-d H:i'
                dateFormat: "d M Y h:i K",
                parseDate: (datestr, format) => {
                    return moment(datestr, format).toDate();
                },
            },
            validDateTime: true,
            validStaff: true
        }
    },
    watch: {
      addTimeKeepingConfig:{
        immediate: true,
        deep: true,
        handler(){
          this.note = '',
          this.staffName = '',
          this.in_date = new Date(),
          this.out_date = new Date();
          this.validDateTime = true;
          this.validStaff = true;
          this.selectedId = '';
        }
      },
      in_date: {
        immediate: true,
        deep: true,
        handler(){
          this.out_date = new Date(this.in_date),
          this.disabledDates.to = new Date(new Date(this.in_date).getFullYear(), new Date(this.in_date).getMonth(), new Date(this.in_date).getDate())
        }
      }
    },
    methods: {
        checkValidDateTime() {
            if(this.in_date && this.out_date) {
                if(new Date(this.in_date) < new Date(this.out_date)) {
                    return true;
                }
            } else {
                if(!this.out_date) {
                    return true;
                }
            }
            return false;
        },
        selectId(e) {
          this.staffName = e.name;
          this.selectedId = e.user_id;
        },
        addTimeKeeping() {
            this.validDateTime = this.checkValidDateTime();
            this.validStaff = this.selectedId != '' ? true : false;
            if(this.validDateTime && this.validStaff) {
                const obj = {
                  staff_id : this.selectedId,
                  time_in : moment(this.in_date).format('MM/DD/YYYY HH:mm'),
                //   time_out : this.out_date ? moment(this.out_date).format('MM/DD/YYYY HH:mm') : null,
                  note : this.note,
                  "per-page" : 10
                }
                if(this.out_date) {
                    obj.time_out = moment(this.out_date).format('MM/DD/YYYY HH:mm');
                }
                this.$emit("AddTimeKeeping", obj)
            }
        },
        closeSidebar() {
            this.addTimeKeepingConfig.isOpen = false;
        }
    },
    computed: {
        staffList() {
            return this.$store.getters['staffList/staffList'];
        }
    }
}
</script>
